<nav #navbar id="hgx-topbar" class="navbar active">
  <div class="hgx-topbar">
    <div class="hgx-topbar-brand">
      <button type="button" class="hgx-icon-btn hgx-only-mobile" aria-label="Ouvrir le menu"
        (click)="mobileMenuSidebarOpen($event, 'overlay-open')">
        <i class="material-icons-outlined" aria-hidden="true">menu</i>
      </button>
      <a class="hgx-brand" routerLink="dashboard/main" aria-label="Hotelgex, tableau de bord">
        <span class="hgx-brand-mark" aria-hidden="true">H</span>
        @if (!isSidebarCollapsed) {
        <span class="hgx-brand-name">Hotelgex</span>
        }
      </a>
    </div>

    <button type="button" class="hgx-icon-btn hgx-only-desktop" (click)="callSidemenuCollapse()"
      [attr.aria-label]="isSidebarCollapsed ? 'Déplier le menu' : 'Replier le menu'">
      <i class="material-icons-outlined" aria-hidden="true">menu</i>
    </button>

    @if (user?.hotel_libelle) {
    <span class="hgx-hotel">
      <i class="material-icons-outlined" aria-hidden="true">apartment</i>
      {{ user.hotel_libelle | titlecase }}
    </span>
    }

    <div class="hgx-topbar-actions">
      <button type="button" class="hgx-icon-btn" (click)="toggleTheme()"
        [attr.aria-label]="isDark ? 'Passer en mode clair' : 'Passer en mode sombre'"
        [attr.title]="isDark ? 'Passer en mode clair' : 'Passer en mode sombre'">
        <i class="material-icons-outlined" aria-hidden="true">{{ isDark ? 'light_mode' : 'dark_mode' }}</i>
      </button>

      <button type="button" class="hgx-icon-btn hgx-notif-btn" [matMenuTriggerFor]="notificationMenu"
        [attr.aria-label]="unreadCount > 0 ? 'Notifications, ' + unreadCount + ' non lues' : 'Notifications'">
        <i class="material-icons-outlined" aria-hidden="true">notifications</i>
        <span *ngIf="unreadCount > 0" class="notif-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </button>
      <mat-menu #notificationMenu="matMenu" class="nfc-menu" xPosition="before">
        <div class="nfc-header" (click)="$event.stopPropagation()">
          <div class="nfc-header-left">
            <span class="nfc-title">Notifications</span>
            <span *ngIf="unreadCount > 0" class="nfc-count-badge">{{ unreadCount }}</span>
          </div>
          <a class="nfc-mark-as-read" (click)="notificationService.markAllAsRead(); $event.stopPropagation()">
            Tout marquer comme lu
          </a>
        </div>
        <div class="nfc-dropdown">
          <ng-scrollbar style="height: 360px" visibility="hover">
            <ng-container *ngIf="(notifications$ | async) as notifs">
              <div *ngIf="notifs.length === 0" class="nfc-empty">
                <i class="material-icons-outlined" aria-hidden="true">notifications_off</i>
                <p>Aucune notification</p>
              </div>
              <div class="nfc-item" *ngFor="let n of notifs" [class.nfc-item-unread]="!n.is_marked_as_read"
                (click)="notificationService.markAsRead(n.id); $event.stopPropagation()">
                <div class="nfc-item-body">
                  <div class="nfc-item-title">{{ n.libelle }}</div>
                  <div class="nfc-item-desc" *ngIf="n.description">{{ n.description }}</div>
                  <div class="nfc-item-time">{{ n.created_at | date: 'dd/MM/yyyy HH:mm' }}</div>
                </div>
                <div class="nfc-item-status" *ngIf="!n.is_marked_as_read">
                  <span class="nfc-dot" aria-label="Non lue"></span>
                </div>
              </div>
            </ng-container>
          </ng-scrollbar>
        </div>
        <div class="nfc-footer" (click)="$event.stopPropagation()">
          <a class="nfc-refresh" (click)="notificationService.loadNotifications()">Actualiser</a>
        </div>
      </mat-menu>

      <button type="button" class="hgx-user" [matMenuTriggerFor]="profilemenu">
        @if (user?.image_url) {
        <img [src]="user.image_url" class="hgx-avatar" width="36" height="36" alt=""
          (error)="user.image_url = null">
        } @else {
        <span class="hgx-avatar" aria-hidden="true">{{ initiales }}</span>
        }
        <span class="hgx-user-info">
          <span class="hgx-user-name">{{ user?.prenom | titlecase }} {{ user?.nom | titlecase }}</span>
          @if (user?.role_libelle) {
          <span class="hgx-user-role">{{ user.role_libelle | titlecase }}</span>
          }
        </span>
        <i class="material-icons-outlined hgx-user-chevron" aria-hidden="true">expand_more</i>
      </button>
      <mat-menu #profilemenu="matMenu" class="profile-menu" xPosition="before">
        <button mat-menu-item (click)="logout()">
          <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>Déconnexion
        </button>
      </mat-menu>
    </div>
  </div>
</nav>
